import { combineReducers } from 'redux';

import auth from './features/auth';
import { STATE as AUTH_STATE } from './features/auth/types/state';

import directories from './features/directories';
import { STATE as DIRECTORIES_STATE } from './features/directories/types/state';

import cards from './features/cards';
import { STATE as CARDS } from './features/cards/types/state';

import user from './features/user';
import { STATE as USER } from './features/user/types/state';

import {
  APPLICATION_STATE,
  applicationReducer
} from 'entities/application';

import {
  REPORTS_STATE,
  reportsReducer
} from 'entities/reports';

import {
  NAVIGATION_STATE,
  navigationReducer
} from 'entities/navigation';

import {
  DRIVERS_STATE,
  driversReducer
} from 'entities/drivers';

import {
  CARS_STATE,
  carsReducer
} from 'entities/cars';

import {
  MAP_STATE,
  mapReducer
} from 'entities/map';

import {
  STATIONS_STATE as STATIONS_WITH_PRICES_STATE,
  stationsReducer
} from 'entities/stations';

import {
  BRANDS_STATE,
  brandsReducer
} from 'entities/brands';

import {
  CARDS_STATE,
  cardsReducer
} from 'entities/cards';

const reducer = combineReducers({
  [APPLICATION_STATE]: applicationReducer,
  [AUTH_STATE]: auth,
  [DIRECTORIES_STATE]: directories,
  [CARDS]: cards,
  [USER]: user,
  [REPORTS_STATE]: reportsReducer,
  [NAVIGATION_STATE]: navigationReducer,
  [DRIVERS_STATE]: driversReducer,
  [CARS_STATE]: carsReducer,
  [MAP_STATE]: mapReducer,
  [STATIONS_WITH_PRICES_STATE]: stationsReducer,
  [BRANDS_STATE]: brandsReducer,
  [CARDS_STATE]: cardsReducer
});

export default reducer;
